export default __webpack_public_path__ + "static/media/yiqi.cdd43087.jpg";